import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faPhone, 
    faEnvelope, 
    faArrowRight, 
    faCopyright, 
    faLocationDot,
    faShareNodes,
    faGlobe
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import logo from '../components/img/logo.webp';

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <>
            <style>{`
                .main-footer {
                    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
                    color: #cbd5e1;
                    font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
                }

                .footer-logo {
                    height: 65px;
                    margin-bottom: 25px;
                    transition: filter 0.3s ease;
                    border-radius: 8px;
                }

                .footer-heading {
                    color: #ffffff;
                    font-size: 1.2rem;
                    font-weight: 700;
                    margin-bottom: 25px;
                    position: relative;
                    padding-bottom: 12px;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }

                .footer-heading::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 40px;
                    height: 3px;
                    background: #ffc107;
                    border-radius: 2px;
                }

                .footer-link {
                    color: #94a3b8;
                    text-decoration: none;
                    font-size: 0.9rem;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                }

                .footer-link:hover {
                    color: #ffc107;
                    transform: translateX(5px);
                }

                .service-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 0 15px;
                }

                .social-box {
                    display: flex;
                    gap: 12px;
                    margin-top: 20px;
                }

                .social-circle {
                    width: 40px;
                    height: 40px;
                    background: rgba(255, 255, 255, 0.08);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    color: #fff;
                    transition: all 0.3s ease;
                    text-decoration: none;
                }

                .social-circle:hover {
                    background: #ffc107;
                    color: #0f172a;
                    transform: translateY(-3px);
                }

                .contact-item {
                    display: flex;
                    align-items: flex-start;
                    margin-bottom: 18px;
                    font-size: 0.9rem;
                }

                .contact-icon {
                    color: #ffc107;
                    margin-right: 15px;
                    margin-top: 4px;
                }

                .bottom-strip {
                    background: #0a0f1d;
                    border-top: 1px solid rgba(255, 255, 255, 0.05);
                    padding: 20px 0;
                }

                .ign-brand {
                    color: #ffc107;
                    font-weight: 600;
                    text-decoration: none;
                }

                @media (max-width: 991px) {
                    .service-grid { grid-template-columns: 1fr; }
                    .main-footer { text-align: center; }
                    .footer-heading::after { left: 50%; transform: translateX(-50%); }
                    .footer-link { justify-content: center; }
                    .social-box { justify-content: center; }
                    .contact-item { justify-content: center; }
                }
            `}</style>

            <footer className="main-footer pt-5">
                <div className="container pb-5">
                    <div className="row">
                        {/* Column 1: About */}
                        <div className="col-lg-4 col-md-12 mb-4">
                            <img src={logo} className="footer-logo" alt="NRIWA" />
                            <p className="pe-lg-4" style={{ lineHeight: '1.7' }}>
                                NRI Welfare Association (NRIWA) is dedicated to serving the unique needs of non-residents,
                                offering expert guidance in legal, healthcare, and business domains within India.
                            </p>
                            <div className="social-box">
                                <a href="#" className="social-circle"><FontAwesomeIcon icon={faShareNodes} /></a>
                                <a href="#" className="social-circle"><FontAwesomeIcon icon={faGlobe} /></a>
                                <a href="#" className="social-circle"><FontAwesomeIcon icon={faShareNodes} /></a>
                            </div>
                        </div>

                        {/* Column 2: Services Grid */}
                        <div className="col-lg-5 col-md-12 mb-4">
                            <h4 className="footer-heading">Services</h4>
                            <div className="service-grid">
                                <Link to="/Education" className="footer-link"><FontAwesomeIcon icon={faArrowRight} className="me-2" style={{fontSize: '10px'}}/> Education</Link>
                                <Link to="/Healthcare" className="footer-link"><FontAwesomeIcon icon={faArrowRight} className="me-2" style={{fontSize: '10px'}}/> Healthcare</Link>
                                <Link to="/Tax" className="footer-link"><FontAwesomeIcon icon={faArrowRight} className="me-2" style={{fontSize: '10px'}}/> Taxation</Link>
                                <Link to="/Matrimonial" className="footer-link"><FontAwesomeIcon icon={faArrowRight} className="me-2" style={{fontSize: '10px'}}/> Matrimonial</Link>
                                <Link to="/Agriculture" className="footer-link"><FontAwesomeIcon icon={faArrowRight} className="me-2" style={{fontSize: '10px'}}/> Agriculture</Link>
                                <Link to="/Oldage" className="footer-link"><FontAwesomeIcon icon={faArrowRight} className="me-2" style={{fontSize: '10px'}}/> Oldage Homes</Link>
                                <Link to="/Housing" className="footer-link"><FontAwesomeIcon icon={faArrowRight} className="me-2" style={{fontSize: '10px'}}/> Real Estate</Link>
                                <Link to="/Business" className="footer-link"><FontAwesomeIcon icon={faArrowRight} className="me-2" style={{fontSize: '10px'}}/> Business</Link>
                                <Link to="/Hungerfree" className="footer-link"><FontAwesomeIcon icon={faArrowRight} className="me-2" style={{fontSize: '10px'}}/> Hunger Free</Link>
                                <Link to="/Cancer" className="footer-link"><FontAwesomeIcon icon={faArrowRight} className="me-2" style={{fontSize: '10px'}}/> Cancer Care</Link>
                            </div>
                        </div>

                        {/* Column 3: Contact */}
                        <div className="col-lg-3 col-md-12">
                            <h4 className="footer-heading">Reach Us</h4>
                            <div className="contact-item">
                                <FontAwesomeIcon icon={faLocationDot} className="contact-icon" />
                                <span>Nagpur, Maharashtra, India</span>
                            </div>
                            {/* <div className="contact-item">
                                <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                                <span>+91 99999 99999</span>
                            </div> */}
                            <div className="contact-item">
                                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                                <span>arshad@nriwa.com</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bottom-strip">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center text-muted small">
                                <p className="mb-0">
                                    <FontAwesomeIcon icon={faCopyright} className="me-1" />
                                    {currentYear} <strong>NRIWA.COM</strong>. All Rights Reserved.
                                </p>
                                <p className="mb-0 mt-1">
                                    Developed by <a href="#" className="ign-brand">IGN SOFTWARES</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}